export const ADMINISTER_HAM = 'ADMINISTER_HAM';
export const VIEW_HAM = 'VIEW_HAM';
export const SERVICE_DESK_USER = 'SERVICE_DESK_USER';
export const JIRA_ADMIN = 'JIRA_ADMIN';
export const ASSETS_ADMIN = 'ASSETS_ADMIN';
export const HAM_USER = 'HAM_USER';
export const HAM_ADMIN = 'HAM_ADMIN';

export type HamPermissionKey =
	| 'ADMINISTER_HAM'
	| 'VIEW_HAM'
	| 'SERVICE_DESK_USER'
	| 'JIRA_ADMIN'
	| 'ASSETS_ADMIN'
	| 'HAM_USER'
	| 'HAM_ADMIN';

export type HamPermissions = Readonly<Record<HamPermissionKey, boolean>>;
